const inputFieldStyles = [
  'border-[--c-textinput-border]',
  'rounded-[8px]',
  'h-[40px]',
  'px-2',
  'border-[1px]',
  'shrink',
  'min-w-[50px]',
  'max-w-full',
];

export const SelectBox: React.FC<{
  placeholder: string;
  name: string;
  value?: string;
  options: string[];
  className?: string;
  ariaLabel?: string;
  onChange?: (v: string) => void | undefined;
  autoComplete?: React.InputHTMLAttributes<HTMLInputElement>['autoComplete'];
  id?: string;
}> = (props) => {
  const options = [
    <option key="placeholder" value="" disabled>
      {props.placeholder}
    </option>,
    ...props.options.map((o) => (
      <option key={o} value={o}>
        {o}
      </option>
    )),
  ];
  return (
    <select
      className={inputFieldStyles.join(' ') + ' ' + props.className}
      name={props.name}
      value={props.value ?? ''}
      placeholder={props.placeholder}
      onChange={(e) => {
        if (props.onChange) props.onChange(e.target.value);
      }}
      aria-label={props.ariaLabel}
      autoComplete={props.autoComplete}
      id={props.id}
    >
      {options}
    </select>
  );
};
